import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="route-checklist"
export default class extends Controller {
  static targets = ['item']

  connect() {
    this.itemTargets.forEach((element) => {
      element.checked = (localStorage.getItem(element.name) === '1')
    })
  }

  change(event) {
    if(event.target.checked) {
      localStorage.setItem(event.target.name, '1')
    } else {
      localStorage.removeItem(event.target.name)
    }
  }
}
